import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
const loadMessages = async (locale) => {
    const { default: messages } = (await import(`../../lang/${locale}.json`));
    return {
        [locale]: Object.entries(messages).reduce((acc, [key, value]) => {
            acc[key] = value.defaultMessage;
            return acc;
        }, {}),
    };
};
const defaultMessages = { en: {} };
export const IntlProvider = ({ children, locale }) => {
    const [messages, setMessages] = useState(defaultMessages);
    useEffect(() => {
        if (locale === "en") {
            return;
        }
        if (!messages[locale]) {
            void loadMessages(locale).then((data) => {
                if (data) {
                    setMessages(prev => ({
                        ...prev,
                        ...data,
                    }));
                }
            });
        }
    }, [locale, messages]);
    if (messages[locale]) {
        return (_jsx(ReactIntlProvider, { locale: locale, messages: messages[locale], children: children }, locale));
    }
    else {
        return (_jsx(ReactIntlProvider, { defaultLocale: "en", locale: "en", messages: defaultMessages.en, children: children }, "en"));
    }
};
